<template>
  <utd-button class="utd-pill-button" v-bind="$attrs">
    <slot />
  </utd-button>
</template>

<script>
import UtdButton from './UtdButton.vue';

export default {
    components: { UtdButton },
    inheritAttrs: false
};
</script>

<style lang="less" scoped>
@import '~_acaAssets/wkce/colors/wkce-app-styles';

.utd-pill-button {
  .border-radius(1rem);
  border-style: solid;
  border-width: 1px;
  height: auto;
  line-height: normal;
  padding: 6px 12px;
  background-color: @DS1-PILL-BACKGROUND-COLOR;
  border-color: @DS1-PILL-BORDER-COLOR;
  color: @DS1-PILL-TEXT-COLOR;

  &.utd-button-size-small {
    padding-top: 2px;
    padding-bottom: 2px;
  }

  &:hover {
    background-color: @DS1-PILL-HOVER-BACKGROUND-COLOR;
  }
}
</style>